import React, { useState,useEffect} from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../../Common/Header';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";   

import SuccessMsg from '../../Common/SuccessMsg';
import CommonAPI from '../../Common/CommonAPI';
import CommonAPI2 from '../../Common/FD_BILL_APIs';
import moment from 'moment';
import FadeLoader from "react-spinners/HashLoader"; 

function  BillMaintain (props) {   
    var BillId = JSON.parse(sessionStorage.getItem("BillValues")).BillRef;

    const [MainCustomerName,setMainCustomerName] = useState();
    const [SuccessLoading,setSuccessLoading] = useState(true);
    const [BillList,setBillList] = useState([]);
    const [BillRef,setBillRef] = useState("");
    const [dueDate,setdueDate] = useState("");
    const [Provider,setProvider] = useState("");
    const [BillNUmber,setBillNUmber] = useState("");
    const [PayStart,setPayStart] = useState("");
    const [PayEnd,setPayEnd] = useState("");
    const [PayByAccount,setPayByAccount] = useState("");
    const [BillingAccount,setBillingAccount] = useState("");
    const [PayAmount,setPayAmount] = useState("");
    const [BillFrequency,setBillFrequency] = useState("");
    const [BeneReference,setBeneReference] = useState("");
    const [YourReference,setYourReference] = useState("");
    const [SuccessMSG,setSuccessMSG] = useState(false);
    const [CancelPayment,setCancelPayment] = useState(false);
    const [EnteredPassword,setEnteredPassword] = useState("");
    const [ErrorMSG,setErrorMSG] = useState("");
    const [EditBill,setEditBill] = useState(false);
    const [Recurring,setRecurring] = useState();
    const [PayMethod,setPayMethod] = useState();
    const [ScheduleBillDate,setScheduleBillDate] = useState();
    
    
    useEffect( () => {
        GetBillDetailsAPI();        
      },[]);

      const GetBillDetailsAPI = () =>{
        CommonAPI2. ActiveBillDetails({BillId:BillId},(result) =>{   
            if(result){                    
                setBillList(result.billPayments);
                setBillRef(result.billRef);
                setdueDate(result.dueDateMilli);
                setProvider( result.provider);
                setBillNUmber( result.billNo);
                setPayStart( result.startDate);
                setPayEnd( result.endDate);
                setPayByAccount(result.accountNo);
                setBillingAccount( result.billingAccount);
                setPayAmount(result.payAmount);
                setBillFrequency(result.frequency);
                setBeneReference(result.beneReference);
                setYourReference(result.bankReference);   
                setRecurring(result.frequency?"R":"S");
                setPayMethod(result.endDate?"R":"N") ;
                setScheduleBillDate(result.dueDateMilli);           
               setSuccessLoading(false);
            } 
            if(result.message){
                console.log("Invalid Request!");
                setSuccessLoading(false);
            }          
        });
      }

      const CheckFirstPassword = () =>{ 
        if(PayAmount<=0){
          setErrorMSG("Transfer amount less than 0");
        }else if(Recurring==="R" && !BillFrequency){
          setErrorMSG("Select the Frequency");
        }else if(!Recurring){
          setErrorMSG("Select the Payment Method");
        }else if(!PayMethod){
          setErrorMSG("Select the Payment Method");
        }else{
          CommonAPI.CheckPassword({password:EnteredPassword},(result) =>{ 
          var pw = result.password;
            if(pw==="true"){  
              setErrorMSG("");
              AmendBillAPI();
            }else{
            setErrorMSG("Enter Correct Password");
            }
          });       
      }    
     }

     const AmendBillAPI = () =>{
       setSuccessLoading(true);
      var scheduleDate= moment(ScheduleBillDate).format("YYYY-MM-DD");

      if(Recurring==="S") {
        setPayEnd("");
        setBillFrequency("")
      } else {
        setPayEnd(PayEnd?PayEnd:null)
      }

        CommonAPI2.AmmendBill({
            BillID:BillId,
            Amount:PayAmount,
            SelectedFrequency:BillFrequency,
            PayEnd:PayEnd,
            scheduleDate:scheduleDate,
            CheckRecurring:Recurring,
            YourReference:YourReference,
        },(result)=>{
            if(result.message=="Success !"){
              setErrorMSG("");
              setSuccessMSG(true);
              setSuccessLoading(false);
                }else{
                  setErrorMSG(result.message);
                  setSuccessLoading(false);
                }
              return result;
          
        })
      }

const ResponseLoadingModal = () => {
        return(
            <Modal
            size="lg"
            centered 
            className="loading1" show={SuccessLoading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={SuccessLoading}
                />       
           </Modal>
         )
      }

      if(SuccessMSG){
        return(
        <SuccessMsg ConfirmSuccess={SuccessMSG} 
        Close={props.toggle} head="SUCCESS" head2="" 
        contentline1="Your Bill Payment Successfully Amended"
         />
         )
    }else if(SuccessLoading){
      return ( <div>{ResponseLoadingModal()}</div> );
  }
        return (

            <Modal
              show={props.isOpen}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered 
              backdrop="static"
              onHide={props.toggle}
            >
              <Modal.Header closeButton>
                <Modal.Title className='hselect' id="contained-modal-title-vcenter">
                  <p className='modal-head-f'>MAINTAIN</p><br/>BILL PAYMENT
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                
                <Form > 
                     <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                            REFERENCE NUMBER
                        </Form.Label>
                        <Col sm={7}>
                        <Form.Label className="c-font">
                            {BillRef}
                        </Form.Label>
                        </Col>
                    </Form.Group>
                        <Form.Label className="c-font mb-1">
                        <b>SENDER DETAILS</b>
                        </Form.Label>
                    <Form.Group as={Row} className="block" >
                        <Form.Label className="c-font" column sm={5}>
                            ACCOUNT NUMBER
                        </Form.Label>
                        <Col sm={7}>
                        <Form.Label className="c-font">
                            {PayByAccount}
                        </Form.Label>
                        </Col>
                    </Form.Group>                   
                        <Form.Label className="c-font">
                        <b>BENEFICIARY DETAILS</b>
                        </Form.Label>                    
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                          SERVICE PROVIDER
                        </Form.Label>
                        <Form.Label className="c-font" column sm={7}>
                            {Provider}
                        </Form.Label>
                    </Form.Group>
                    
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                          BILLING ACCOUNT NUMBER
                        </Form.Label>
                        <Form.Label className="c-font" column sm={7}>
                            {BillingAccount}
                        </Form.Label>
                    </Form.Group>
                    
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                        PAYMENT AMOUNT Rs.
                        </Form.Label>
                        <Col sm={7} >
                         <Form.Control 
                         onChange = {(e)=>{setPayAmount(e.target.value)}}
                         value={PayAmount}
                          className="form-h2" size="sm" type="email" placeholder="AMOUNT" />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                        YOUR REFERENCE
                        </Form.Label>
                        <Col sm={7} >
                         <Form.Control  
                         value={YourReference}
                         onChange= {(e)=>setYourReference(e.target.value)}
                         className="form-h2" size="sm" type="email" placeholder="REFERENCE" />
                        </Col>
                    </Form.Group>
                    {Recurring==="R"?
                    <div>
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                        PAYMENT METHOD
                        </Form.Label>
                        <Col sm={7}>
                        <Form.Select 
                        value={PayMethod}
                        onChange={(value)=>setPayMethod(value.target.value)}
                        size="sm" className="form-h2 ">
                            <option value="">Select</option>
                            <option value="R">Set Up Recurring Transfer</option>
                            <option value="N">Set Up Recurring Transfer Until Further Notice</option>                            
                        </Form.Select>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                         PAYMENT DATE
                        </Form.Label>
                        <Col sm={7} >
                            <div className='d-flex flex-row align-items-center'> 
                            <Form.Label className="c-font" column sm={4}>
                                21/05/2022
                            </Form.Label> 
                            <label className='lable l-width'> To</label>
                            {PayMethod ==="R"?
                            <DatePicker
                                className="datepicker"
                                selected={PayEnd}
                                  onChange={(e)=>setPayEnd(e)}
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                            />
                            :PayMethod==="N"?
                            <Form.Label className="c-font s-top2" >
                                U.F.N
                            </Form.Label>
                            :
                            <Form.Label className="c-font s-top2" >
                             Select the Payment method
                            </Form.Label>
                              }
                            </div>                  
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                            FREQUENCY
                        </Form.Label>
                        <Col sm={7}>
                        <Form.Select 
                        value={BillFrequency}
                        onChange={(value)=>setBillFrequency(value.target.value)}
                        size="sm" className="form-h2 ">
                            <option value="">Select</option>
                            <option value="M">Monthly</option>
                            <option value="D">Daily</option>
                            <option value="W">Weekly</option>
                            <option value="Q">Quarterly</option>
                            <option value="H">Half Yearly</option>
                            <option value="Y">Yearly</option>                            
                        </Form.Select>
                        </Col>
                    </Form.Group>

                    </div>
                    :
                  <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                         PAYMENT DATE
                        </Form.Label>
                        <Col sm={7} >
                            <div className='d-flex flex-row align-items-center'> 
                            <DatePicker
                                className="datepicker"
                                selected={ScheduleBillDate}
                                onChange={(e)=>setScheduleBillDate(e)}
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                            />
                            </div>                  
                        </Col>
                    </Form.Group>
                    }
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                        PASSWORD TO CONFIRMATION
                        </Form.Label>
                        <Col sm={7} >
                        <Form.Control value = {EnteredPassword}                       
                            onChange={(text)=>setEnteredPassword(text.target.value)} 
                            className={!EnteredPassword?"form-h2 password-f":"form-h2"} size="sm" maxLength={8} type="password" 
                            placeholder="Password"  />
                        </Col>
                    </Form.Group>
                    <p className='vali-txt'>{ErrorMSG}</p> 
                </Form>
              </Modal.Body>
              <Modal.Footer>  
                <Button className="btn-logout" onClick={()=>CheckFirstPassword()}>UPDATE</Button>
              </Modal.Footer>
            </Modal>
          );
    }

export default BillMaintain;